import { useState } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Icon } from 'platfi-ui-components';

import { bemClassName } from 'utils/BEMHelper';

import styles from './ShareableReportLenderNoteCard.scss';

const maxMessageSize = 275;

const ShareableReportLenderNoteCard = ({ message }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div styleName="m-shareable-report-lender-note-card">
      <div
        styleName={bemClassName('m-shareable-report-lender-note-card__message', {
          expanded: isExpanded,
        })}
      >
        {message}
      </div>
      {message.length > maxMessageSize && !isExpanded && (
        <div
          tabIndex={0}
          role="button"
          onClick={() => setIsExpanded(true)}
          onKeyPress={() => setIsExpanded(true)}
          styleName="m-shareable-report-lender-note-card__more"
        >
          <Icon
            styleName="m-shareable-report-lender-note-card__more-icon"
            className="a-svg-base"
            icon="dot"
          />
        </div>
      )}
    </div>
  );
};

ShareableReportLenderNoteCard.propTypes = {
  message: PropTypes.string,
};

export default CSSModules(ShareableReportLenderNoteCard, styles, { allowMultiple: true });
